import { render, staticRenderFns } from "./CAHG1220.vue?vue&type=template&id=7c098972&scoped=true"
import script from "./CAHG1220Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAHG1220Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAHG1220.vue?vue&type=style&index=0&id=7c098972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c098972",
  null
  
)

export default component.exports